import React from "react";
import { cn } from "@utils";

function SectionHeader({ children, noBorder }) {
  return (
    <div
      className={cn(
        "w-full pb-6 flex flex-col items-start",
        noBorder ? "" : "border-b border-zinc-200",
      )}
    >
      {children}
    </div>
  );
}

export default SectionHeader;
